import React, { FC } from 'react';
import { Box } from '@mui/material';
import RegisterOutForm from '../components/FormComponents/RegisterOutForm';
// import CompanyLogin from '../components/LoginScreenComponents/CompanyLogin';

const RegisterOut: FC = () => {
  return (
    <Box
      sx={{
        height: '100%',
        minHeight: '100vh',
        width: '100vw',
        textAlign: 'left',
      }}>
      <Box
        sx={{
          height: '100%',
          minHeight: '100vh',
          width: '100vw',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        <Box sx={{ paddingTop: '10vh', paddingBottom: '20vh' }}>
          <RegisterOutForm />
        </Box>
      </Box>
    </Box>
  );
};

export default RegisterOut;
